// src/pages/support/components/Modal.jsx
import React from "react";

function Modal({ title, onClose, children }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(0,0,0,0.85)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-[720px] max-h-[92vh] rounded-3xl border backdrop-blur-xl overflow-hidden"
        style={{
          backgroundColor: "rgba(17,24,39,0.96)",
          borderColor: "rgba(16,185,129,0.28)",
          boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
          direction: "rtl",
        }}
      >
        <div
          className="flex items-center justify-between p-5 border-b"
          style={{ borderColor: "rgba(55,65,81,0.5)" }}
        >
          <h3 className="text-white text-lg font-bold">{title}</h3>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl flex items-center justify-center hover:scale-105 transition"
            style={{ backgroundColor: "rgba(16,185,129,0.15)", border: "1px solid rgba(16,185,129,0.25)" }}
          >
            <svg className="w-6 h-6 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-5 overflow-y-auto" style={{ maxHeight: "calc(92vh - 70px)" }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;